import React from "react";
import "./style.scss";

import { defaultProps } from "./props/defaultProps";
import { propTypes } from "./props/propTypes";
import { FormControlLabel, FormGroup, Checkbox } from "@mui/material";

import { ReactComponent as FilledIcon } from "../../assets/icons/tick_filled.svg";
import { ReactComponent as UnFilledIcon } from "../../assets/icons/tick_unfilled.svg";

const Index = (props) => {
  const { data, onClick, className, id, status } = props;
  return (
    <FormGroup>
      {data?.length
        ? data.map((item) => {
            return (
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<UnFilledIcon />}
                    checkedIcon={<FilledIcon />}
                    inputProps={{ "aria-label": "controlled" }}
                    checked={
                      status ? true : item?.term_id === id ? true : false
                    }
                  />
                }
                className={className}
                style={{
                  border: status
                    ? "0.0625rem solid #D25333"
                    : id === item?.term_id
                    ? "0.0625rem solid #D25333"
                    : "0.0625rem solid #B4B4B4",
                }}
                label={
                  <>
                    {item?.image_url && (
                      <img src={item?.image_url} alt="bundle" />
                    )}
                    {item?.title ? <span>{item?.title}</span> : null}
                    {item?.description ? (
                      <span className="description">{item?.description}</span>
                    ) : (
                      ""
                    )}
                  </>
                }
                onClick={(event) => {
                  if (status) {
                    return;
                  } else {
                    onClick({ event, id: item?.term_id, item });
                  }
                }}
              />
            );
          })
        : null}
    </FormGroup>
  );
};

export default Index;

Index.defaultProps = defaultProps;
Index.propTypes = propTypes;
